import { Inject, Injectable, Optional } from '@angular/core';

import { Bloc, BLOC_DEBUG } from '@connect-services/client/blocs/bloc';
import { PeopleService } from '@connect-services/client/sdk/api';

@Injectable({
    providedIn: 'root',
})
export class PeopleListBloc extends Bloc<PeopleService['personControllerGet']> {
    public constructor(service: PeopleService, @Inject(BLOC_DEBUG) @Optional() debug?: boolean) {
        super(service.personControllerGet.bind(service), {
            debug: debug ?? false,
        });
    }
}
